import _debounce from "lodash/debounce";
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { Component } from 'react';
import classnames from 'classnames';
import { withRouter, browserHistory } from 'react-router';
import { instantScrollTop } from 'swag-client-common/utils/tricks';
import Page from '../../../page';
import { RelatedProductsPopup } from '../../../popups/related-products-popup';
import { ProductionTimeDialogForProduct } from '../../../info/production-time-dialog';
import ShareMockupDesignPopup from '../../../popups/share-mockup-design-popup';
import { CollectSizesPopup } from '../../../popups/collect-sizes-popup';
import { isMobile } from '../../../../utils/ui.utils';
import { AddToCartWarningPopup } from '../../../popups/add-to-cart-warning-popup';
import { LimitedEditionCountdown } from '../../../info/limited-edition-countdown';
import { LimitedEditionInStock } from '../../../info/limited-edition-in-stock';
import { LimitedEditionInStockStyle } from '../../../info/limited-edition-in-stock/limited-edition-in-stock';
import { LimitedEditionCountdownStyle } from '../../../info/limited-edition-countdown/limited-edition-countdown';
import { RemoveRelatedProductWarning } from '../../../popups/remove-related-product-warning';
import { UnavailableSizesPopup } from '../../../popups/unavailable-sizes-popup';
import { DebossedEmbelishmentMethodPopup } from '../../../popups/debossed-embelishment-method-popup';
import { LaserEngravedEmbelishmentMethodPopup } from '../../../popups/laser-engraved-embelishment-method-popup';
import { SuperSpeedColorLimitationPopup } from '../../../popups/super-speed-color-limitation-popup';
import { MaxPrintColorsLimitExceededPopup } from '../../../popups/max-print-colors-limit-exceeded-popup';
import { isPhoneShownProps } from './components/get-header-props/get-phone-shown-props';
import { Details } from './components/details';
import { ProductPreviews } from './components/product-previews';
import { ProductEditor, HiddenProductEditor } from './components/product-editor';
import { SuggestedProducts } from './components/suggested-products';
import { Breadcrumbs } from './components/breadcrumbs';
import { isPropsChanged, isThereNoAnyMedia } from './connect/product-page.utils';
import classes from './product.scss';
import { ProductInformation } from './components/product-information';
import { AllProductImages } from './components/all-product-images';
import { MobileFavoriteButton } from './components/mobile-favourite-button';
class ProductPage extends Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    const {
      logos,
      layers,
      texts
    } = prevState;
    const skipMessage = JSON.parse(localStorage.getItem('skipMessage')); // hook that allow skip leave message for autotests
    const nextState = {
      logos: nextProps.logos,
      layers: nextProps.layers,
      texts: nextProps.texts,
      productId: nextProps.productId
    };
    const isNoMedia = isThereNoAnyMedia(nextProps.logos, nextProps.layers, nextProps.texts);
    const isChanged = isPropsChanged({
      prev: logos,
      next: nextProps.logos
    }, {
      prev: layers,
      next: nextProps.layers
    }, {
      prev: texts,
      next: nextProps.texts
    });
    if (isNoMedia && !nextProps.isBoxProductsWereChanged || skipMessage) {
      window.onbeforeunload = null;
      return nextState;
    }
    if (isChanged || nextProps.isBoxProductsWereChanged) {
      const {
        router,
        route
      } = nextProps;
      router.setRouteLeaveHook(route, nextLocation => {
        if (!window.onbeforeunload) {
          return true;
        }
        window.location.href = `${window.location.origin}${nextLocation.pathname}${nextLocation.search}`;
        return false;
      });
      window.onbeforeunload = () => 'Leave with unsaved change?';
    }
    return nextState;
  }
  constructor(props) {
    super(props);
    _defineProperty(this, "formEl", void 0);
    _defineProperty(this, "elements", void 0);
    _defineProperty(this, "setOpenedHoverState", void 0);
    _defineProperty(this, "backListener", void 0);
    _defineProperty(this, "handleHoverState", hoverState => {
      const {
        openedToolbarItem,
        changeProductImageHoverStatus
      } = this.props;
      if (!hoverState && openedToolbarItem) {
        return null;
      }
      changeProductImageHoverStatus(hoverState);
    });
    _defineProperty(this, "onAddItemToCart", e => {
      e.preventDefault();
      e.stopPropagation();
      const {
        onAddItemToCart
      } = this.props;
      const form = this.formEl;
      const formData = new FormData(form);
      onAddItemToCart(formData);
    });
    _defineProperty(this, "getVariantRef", el => {
      const {
        style
      } = this.state;
      if (el && !style.row && !style.variant) {
        const variantHeight = el.getBoundingClientRect().height;
        const row = {
          minHeight: `${variantHeight + 26}px`
        };
        this.setState({
          style: {
            row
          }
        });
      }
    });
    _defineProperty(this, "handlePageLeave", (leaveMessage = 'Leave with unsaved change?') => {
      const {
        router,
        route
      } = this.props;
      router.setRouteLeaveHook(route, nextLocation => {
        if (!window.onbeforeunload) {
          return true;
        }
        window.location.href = `${window.location.origin}${nextLocation.pathname}${nextLocation.search}`;
        return false;
      });
      window.onbeforeunload = () => leaveMessage;
    });
    _defineProperty(this, "handleContinueClick", () => {
      this.setState({
        isPageBlocked: false
      });
      instantScrollTop();
    });
    _defineProperty(this, "getProductLayout", isLimitedEdition => {
      const {
        isFullScreenMode
      } = this.props;
      const isMobileView = isMobile();
      const isLimitedEditionView = isMobileView && isLimitedEdition;
      const mainContent = /*#__PURE__*/React.createElement("div", {
        onMouseEnter: this.setOpenedHoverState,
        className: classnames(classes.variant, {
          [classes.fullScreenMode]: isFullScreenMode
        }),
        ref: this.getVariantRef,
        id: "variant"
      }, !isFullScreenMode && /*#__PURE__*/React.createElement(Breadcrumbs, null), /*#__PURE__*/React.createElement("div", {
        className: classes.productInformationContainer
      }, /*#__PURE__*/React.createElement(ProductInformation, null)), isLimitedEditionView && /*#__PURE__*/React.createElement("div", {
        className: classes.mobileLimitedEditionWrapper
      }, /*#__PURE__*/React.createElement(LimitedEditionInStock, {
        style: LimitedEditionInStockStyle.FullWidth
      }), /*#__PURE__*/React.createElement(LimitedEditionCountdown, {
        style: LimitedEditionCountdownStyle.FullWidth
      })), /*#__PURE__*/React.createElement(ProductEditor, null), /*#__PURE__*/React.createElement("div", {
        className: classes.onlyTabletOrDesktop
      }, /*#__PURE__*/React.createElement(ProductPreviews, null)));
      if (isMobileView) {
        return /*#__PURE__*/React.createElement("div", {
          className: classnames(classes.sticky, {
            [classes.fullScreenModeWrapper]: isFullScreenMode
          })
        }, mainContent);
      }
      return mainContent;
    });
    this.state = {
      style: {},
      logos: props.logos,
      layers: props.layers,
      texts: props.texts,
      productId: props.productId
    };
    this.elements = {};
    this.setOpenedHoverState = _debounce(() => this.handleHoverState(true), 300);
  }
  componentDidMount() {
    this.backListener = browserHistory.listen(location => {
      if (location.action === 'POP') {
        this.props.hidePopup();
      }
    });
  }
  componentDidUpdate() {
    localStorage.setItem('productId', this.props.productId);
  }
  componentWillUnmount() {
    window.onbeforeunload = null;
    this.backListener();
  }
  render() {
    const {
      views,
      footer,
      isOutOfStock,
      isProductLoaded,
      isFullScreenMode,
      isHiddenSectionShown,
      isBoxProduct,
      isOpenRelatedProductsPopup,
      isLimitedEdition,
      isPreBuiltLimitedCart,
      isResellerInOrderCreationMode,
      loading,
      isCuratedBrandStore
    } = this.props;
    const style = isFullScreenMode && {} || this.state.style;
    return /*#__PURE__*/React.createElement(Page, {
      isPageBlockedImmediately: false,
      footer: footer,
      autoChatbox: false,
      showCategories: false,
      headerIsSticky: true,
      doNotUseSticky: true,
      headerIsViolet: isBoxProduct,
      isLimitedEdition: isLimitedEdition,
      loading: loading,
      isPhoneShown: isPhoneShownProps()
    }, !isProductLoaded && /*#__PURE__*/React.createElement("div", {
      className: classes.blankDiv
    }), !!isProductLoaded && /*#__PURE__*/React.createElement("form", {
      id: "product-form",
      ref: el => {
        this.formEl = el;
      },
      method: "POST",
      encType: "multipart/form-data",
      onSubmit: isOutOfStock ? undefined : e => this.onAddItemToCart(e)
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.container
    }, /*#__PURE__*/React.createElement("input", {
      className: classes.displayNone,
      type: "submit",
      id: "submitForm"
    }), /*#__PURE__*/React.createElement("div", {
      className: classes.row,
      style: style.row
    }, this.getProductLayout(isLimitedEdition), /*#__PURE__*/React.createElement("div", {
      className: classnames(classes.allProductImagesContainer, classes.onlyMobile)
    }, /*#__PURE__*/React.createElement(AllProductImages, null)), !isCuratedBrandStore && /*#__PURE__*/React.createElement("div", {
      className: classnames(classes.onlyMobile)
    }, /*#__PURE__*/React.createElement(MobileFavoriteButton, null)), /*#__PURE__*/React.createElement("div", {
      className: classnames(classes.details, {
        [classes.hide]: isFullScreenMode
      })
    }, /*#__PURE__*/React.createElement(Details, null))), !isFullScreenMode && !isPreBuiltLimitedCart && !isResellerInOrderCreationMode && !isCuratedBrandStore && /*#__PURE__*/React.createElement("div", {
      id: "suggested",
      className: classes.fullRow
    }, /*#__PURE__*/React.createElement(SuggestedProducts, {
      wrapperClassName: classes.suggestedListWrapper,
      titleClassName: classes.suggestedTitle,
      productImageWrapper: classes.suggestedProductImageWrapper,
      imageClassName: classes.suggestedProductImage,
      title: "You might also like"
    }))), /*#__PURE__*/React.createElement("div", {
      className: classes.container
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.invisible
    }, isHiddenSectionShown && !!views.length && views.map(view => /*#__PURE__*/React.createElement(HiddenProductEditor, {
      key: view,
      view: view
    }))))), !isBoxProduct && /*#__PURE__*/React.createElement(RelatedProductsPopup, {
      open: isOpenRelatedProductsPopup
    }), /*#__PURE__*/React.createElement(ProductionTimeDialogForProduct, {
      prerenderForCrawlers: true
    }), /*#__PURE__*/React.createElement(ShareMockupDesignPopup, null), /*#__PURE__*/React.createElement(AddToCartWarningPopup, null), /*#__PURE__*/React.createElement(CollectSizesPopup, null), /*#__PURE__*/React.createElement(RemoveRelatedProductWarning, null), /*#__PURE__*/React.createElement(UnavailableSizesPopup, null), /*#__PURE__*/React.createElement(DebossedEmbelishmentMethodPopup, null), /*#__PURE__*/React.createElement(LaserEngravedEmbelishmentMethodPopup, null), /*#__PURE__*/React.createElement(SuperSpeedColorLimitationPopup, null), /*#__PURE__*/React.createElement(MaxPrintColorsLimitExceededPopup, null));
  }
}
export const Product = withRouter(ProductPage);